// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"107":"4c704ad7","233":"c10757b2","846":"9de07b86"}[chunkId] + ".js";
};